export default __webpack_public_path__ + "static/media/timemarcasproprias.2afe138e.png";